import { Textarea as TremorTextarea, type TextareaProps } from "@tremor/react";
import { cn } from "utils/helpers";
export function Textarea({
  className,
  ...props
}: TextareaProps) {
  return <TremorTextarea className={cn("placeholder:text-tremor-content-subtle", className)} {...props} data-sentry-element="TremorTextarea" data-sentry-component="Textarea" data-sentry-source-file="Textarea.tsx" />;
}